import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>

  // For Staging
  // "homepage": "http://www.tychotechnologies.com/gstsahayak/",
  
  // For Production
  // "homepage": "http://portal.gstsahayak.com/",
  <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
